import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const AccommodationFilterSkeleton = ({ count }) => {
  return (
    <div className="input_check">
      {[...Array(count)].map((_, index) => (
        <div className="d-flex align-items-center pt-0" key={index}>
          <div className="me-3">
            <Skeleton  height={18} width={18} />
          </div>
          <Skeleton height={16} width={100} />
        </div>
      ))}
    </div>
  );
};

export default AccommodationFilterSkeleton;
